<div class="close-panel">
  <button
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<div fxLayout="row" fxLayout.xs="column" class="engergy-layout">
  <as-split direction="horizontal">
    <as-split-area size="30">
      <div fxLayout="column" fxLayout.xs="column">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h6>{{ siteId }}</h6>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-sm-12">
              <button
                class="button-primary"
                bciprimarybutton
                (click)="tree.treeControl.collapseAll()"
              >
                CollapseAll
              </button>
              &nbsp;
              <button
                class="button-primary"
                bciprimarybutton
                (click)="tree.treeControl.expandAll()"
              >
                ExpandAll
              </button>
            </div>
          </div>
          <div class="row" style="overflow-y: scroll; max-height: 650px">
            <mat-tree
              #tree
              [dataSource]="dataSource"
              [(treeControl)]="treeControl"
            >
              <mat-tree-node
                *matTreeNodeDef="let node"
                matTreeNodeToggle
                matTreeNodePadding
                [id]="node.item"
                (click)="activeNode = node"
              >
                <button
                  type="button"
                  (click)="$event.preventDefault()"
                  bciprimarybutton
                  disabled
                  style="border: none"
                ></button>
                <mat-label
                  class="site-tree-node"
                  [ngClass]="{ 'site-node-actived': activeNode === node }"
                  (click)="featureLeafItemSelectionToggle(node)"
                  >{{ node.item }}</mat-label
                >
              </mat-tree-node>

              <mat-tree-node
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
                (click)="activeNode = node"
                [id]="node.item"
              >
                <button
                  type="button"
                  (click)="$event.preventDefault()"
                  bciprimarybutton
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.filename"
                  style="border: none"
                >
                  <mat-icon
                    *ngIf="treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-down"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="!treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-right"
                  ></mat-icon>
                </button>
                <mat-label
                  class="site-tree-node"
                  [ngClass]="{ 'site-node-actived': activeNode === node }"
                  (click)="featureItemSelectionToggle(node)"
                  >{{ node.item }}</mat-label
                >
              </mat-tree-node>
            </mat-tree>
          </div>
        </mat-expansion-panel>
      </div>
    </as-split-area>
    <as-split-area size="70">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h6 style="font-size: 15px">Energy Trend</h6>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          id="timebase-select"
          fxLayout="row"
          fxLayout.xs="column"
          class="site-layout"
        >
          <div
            id="timebase-select-area"
            fxFlex="8%;"
            fxFlex.xs="80%"
            fxLayoutAlign="flex-start"
          >
            <mat-label>Select timebase: &nbsp;</mat-label>
          </div>
          <div
            fxFlex="15%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <mat-form-field>
              <mat-select
                [(ngModel)]="timebase"
                (ngModelChange)="onTimeBaseChange()"
              >
                <mat-option
                  *ngFor="let type of timebaseArr"
                  [value]="type.value"
                >
                  {{ type.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="15%;" fxFlex.xs="80%">
            <mat-label>Select Date Range:&nbsp;</mat-label>
          </div>
          <div
            id="date-change-value"
            fxFlex="42%;"
            fxFlex.xs="80%"
            fxLayout="row"
            fxLayout.xs="column"
          >
            <div>
              <mat-form-field style="width: 180px">
                <input
                  style="width: 120px; margin-top: 7px; margin-left: 10px"
                  matInput
                  [matDatepicker]="picker1"
                  [formControl]="startDate"
                  [max]="max"
                  (dateChange)="validateStartDate()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker1
                  [startView]="startView"
                  (yearSelected)="chosenStartDate_YearHandler($event, picker1)"
                  (monthSelected)="
                    chosenStartDate_MonthHandler($event, picker1)
                  "
                  disabled="false"
                ></mat-datepicker>
                <mat-error *ngIf="startDate.invalid || !isValidStartDate">{{
                  startDateErrorMessage
                }}</mat-error>
              </mat-form-field>
            </div>
            <div style="margin-left: 10px">
              <mat-form-field style="width: 180px">
                <input
                  style="width: 120px; margin-top: 7px; margin-left: 10px"
                  matInput
                  [matDatepicker]="picker2"
                  [formControl]="endDate"
                  [max]="max"
                  (dateChange)="validateEndDate()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker2
                  [startView]="startView"
                  (yearSelected)="chosenEndDate_YearHandler($event, picker2)"
                  (monthSelected)="chosenEndDate_MonthHandler($event, picker2)"
                  disabled="false"
                ></mat-datepicker>
                <mat-error *ngIf="endDate.invalid || !isValidEndDate">{{
                  endDateErrorMessage
                }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div
            id="button-primary-layout"
            fxFlex="16%;"
            fxFlex.xs="80%"
            fxLayout="row"
            fxLayout.xs="column"
          >
            <button
              class="button-primary"
              bciprimarybutton
              (click)="onGenerate()"
              [disabled]="!isValidStartDate || !isValidEndDate"
            >
              Generate
            </button>
            <div>&nbsp;</div>
            <button class="button-primary" bciprimarybutton (click)="onBack()">
              Back
            </button>
          </div>
        </div>

        <div
          fxLayout="row"
          fxLayout.xs="column"
          style="align-items: center !important"
          class="site-layout"
        >
          <div
            fxFlex="10%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          ></div>
          <div
            id="idel-energy"
            fxFlex="20%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <mat-checkbox
              [(ngModel)]="showidleEnergy"
              [disabled]="enableShiftwise"
            >
              &nbsp;Show Idle Energy</mat-checkbox
            >
          </div>
          <div
            fxFlex="15%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <mat-checkbox
              [(ngModel)]="enableShiftwise"
              [disabled]="showidleEnergy"
            >
              &nbsp; Show energy consumption shiftwise</mat-checkbox
            >
          </div>
        </div>

        <div style="margin-top: 20px">
          <div [chart]="columnchart"></div>
        </div>
      </mat-expansion-panel>
    </as-split-area>
  </as-split>
</div>
